export const TASK_CONTROLLER = {
  // 同步 p4p 数据
  postTaskP4p: "/api/v1/task/p4p",
};
